import React from "react";

// Expose l'état du thème et la bascule aux composants (bouton du header).
export const ThemeToggleContext = React.createContext({
  isDark: false,
  toggleTheme: () => {},
});
